<template>
  <v-file-input
    :class="[
      'text-field',
      $style.fileInput
    ]"
    :accept="accept_rule"
    outlined
    v-bind="$attrs"
    v-on="$listeners"
    :rules="rules"
    flat
    prepend-inner-icon="mdi-paperclip"
    prepend-icon
  >
    <slot
      v-for="(_, name) in $slots"
      :slot="name"
      :name="name"
    />
    <template #append-outer />

    <template
      v-if="src"
      #append
    >
      <DownloadBtn
        :class="$style.downloadBtn"
        :src="src"
      />
    </template>

    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </v-file-input>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationMessages, GettingFile } from '@/enums';
import { get_file_extention } from '@/utils';

@Component({
  components: {
    DownloadBtn: () => import('../../../download-btn/DownloadBtn.vue'),
  },
})
export default class FileInput extends Vue {
  @Prop({ type: String, default: '' })
  accept!: string;

  /**
   * Ссылка на файл, которая прилетает с бэка
   * также может измениться на файл,
   * если пользователь выберет новый файл
   */
  @Prop({
    type: [
      String,
      File,
    ],
    default: '',
  })
  src!: string | File;

  get_file_extention = get_file_extention;

  get accept_rule() {
    return this.accept ? this.accept : '.pdf, .jpg, .jpeg, .png, .doc, .docx, .rtf';
  }

  get accept_types() {
    return Object.values(GettingFile.Type).map((e) => `.${e},`).join(' ');
  }

  get rules() {
    const rule = this.accept_rule;
    const arr = [
      (file: File) => !file || file.size <= 10485760 || ValidationMessages.Messages.MAX_FILE_SIZE,
      (file: File) => !file || rule.includes(
        this.get_file_extention(file.name),
      ) || ValidationMessages.Messages.INVALID_FILE_FORMAT,
    ];

    if (this.$attrs.rules && this.$attrs.rules.length) {
      return [
        ...this.$attrs.rules, ...arr,
      ];
    }
    return arr;
  }
}
</script>

<style lang="scss" src="../inputs.scss" />

<style module lang="scss">
@import '../inputs.scss';

.fileInputWrap {
  position: relative;
}

.fileInput {
  :global(.v-icon) {
    color: $accent_darken4;
  }
}

.downloadBtn {
  margin-top: -7px;
}

.remoteFilePlaceholder {
  position: absolute;
  top: 16px;
  left: 40px;
}
</style>
